import React from "react";

const variantStyles = {
  primary: {
    background: "linear-gradient(135deg, #4A6FA5 0%, #3A5A85 100%)",
    color: "#FFFFFF",
    boxShadow: "0 4px 12px rgba(74, 111, 165, 0.3)",
  },
  secondary: {
    background: "#E5E7EB",
    color: "#374151",
    boxShadow: "none",
  },
  danger: {
    background: "transparent",
    color: "#DC2626",
    border: "1.5px solid rgba(220, 38, 38, 0.2)",
    boxShadow: "none",
  },
  outline: {
    background: "transparent",
    color: "#4A6FA5",
    border: "2px solid #4A6FA5",
    boxShadow: "none",
  },
  ghost: {
    background: "transparent",
    color: "#4A6FA5",
    boxShadow: "none",
  },
};

const sizeStyles = {
  sm: { padding: "6px 14px", fontSize: "12px", borderRadius: "6px" },
  md: { padding: "10px 24px", fontSize: "13px", borderRadius: "8px" },
  lg: { padding: "14px 32px", fontSize: "15px", borderRadius: "10px" },
};

const spinnerStyle = {
  width: "16px",
  height: "16px",
  border: "2px solid currentColor",
  borderTopColor: "transparent",
  borderRadius: "50%",
  animation: "loadingBtnSpin 0.6s linear infinite",
  flexShrink: 0,
};

const LoadingButton = ({
  children,
  loading = false,
  disabled = false,
  variant = "primary",
  size = "md",
  onClick,
  style,
  type = "button",
  fullWidth,
  loadingText = "Loading...",
  ...rest
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const base = React.useMemo(() => {
    const variantStyle = variantStyles[variant] || variantStyles.primary;
    const sizeStyle = sizeStyles[size] || sizeStyles.md;

    return {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      border: "none",
      fontWeight: "500",
      cursor: loading || disabled ? "not-allowed" : "pointer",
      transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
      fontFamily: "var(--font-sans)",
      opacity: loading || disabled ? 0.6 : 1,
      width: fullWidth ? "100%" : undefined,
      transform: isHovered && !loading && !disabled ? "translateY(-1px)" : "translateY(0)",
      ...variantStyle,
      ...sizeStyle,
      ...style,
    };
  }, [loading, disabled, variant, size, style, fullWidth, isHovered]);

  return (
    <button
      type={type}
      style={base}
      onClick={onClick}
      disabled={loading || disabled}
      aria-disabled={loading || disabled}
      {...rest}
      onMouseEnter={(e) => {
        if (!loading && !disabled) {
          setIsHovered(true);
        }
        rest.onMouseEnter?.(e);
      }}
      onMouseLeave={(e) => {
        setIsHovered(false);
        rest.onMouseLeave?.(e);
      }}
    >
      {loading ? (
        <>
          <span style={spinnerStyle} />
          {loadingText}
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default LoadingButton;
